import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import type { CreatePlantAnalysisPayload, PlantAnalysisDTO } from './types';

export const usePostPlantAnalysis = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async (data: CreatePlantAnalysisPayload) => {
			try {
				return (await api.post<PlantAnalysisDTO>('/plant-analysis/store', data, {
					params: { forBinding },
				})).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar análise foliar');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['plantAnalysis'] });
			queryClient.invalidateQueries({ queryKey: ['plantAnalysis', variables.area] });
		},
		onError: (error) =>
			console.error(
				'Erro ao criar análise foliar:',
				getApiErrorMessage(error, 'Erro ao criar análise foliar')
			),
	});
};
